<script setup lang="ts">
import { ref, onMounted } from "vue";
import BalanceCard from "@/components/BalanceCard.vue";
import { userInfo } from "@/api/api";

const prepaidBalance = ref<number | string>(0);
const pocBalance = ref<number | string>(0);
const isLoading = ref(true);

onMounted(() => {
  userInfo
    .getBalance()
    .then((res) => {
      if (res) {
        prepaidBalance.value = res.balance;
        pocBalance.value = res.poc_balance;
      }
    })
    .catch((err) => {
      console.error(err);
      // Set balances to N/A on error
      prepaidBalance.value = "N/A";
      pocBalance.value = "N/A";
    })
    .finally(() => {
      isLoading.value = false;
    });
});
</script>

<template>
  <div class="w-full flex flex-col items-center pb-4">
    <div class="w-full max-w-md flex flex-col gap-4">
      <!-- Prepaid Balance Card -->
      <BalanceCard :title="$t('profile.prepaidBalance')" :balance="prepaidBalance" :loading="isLoading" />

      <!-- POC Balance Card -->
      <BalanceCard :title="$t('profile.pocBalance')" :balance="pocBalance" :loading="isLoading" />
    </div>
  </div>
</template>
